<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">{{ title | translate }}</h2>
    @if (text) {
      <h4 class="modal-sub-title pull-left mr-4">{{ text | translate }}</h4>
    }
    @if (!hideCloseBtn) {
      <button
        type="button"
        class="close pull-right"
        title="{{ 'CLOSE' | translate }}"
        [attr.aria-label]="'CLOSE' | translate"
        (click)="hide()"
      ></button>
    }

    <div class="col-12 text-center mt-4" [hidden]="!showSpinner">
      <span
        class="spinner-border spinner-border spinner-border-lg text-secondary"
        [ngStyle]="{
          animation: !showSpinner
            ? 'initial'
            : 'spinner-border 0.75s linear infinite',
        }"
        role="status"
        aria-hidden="true"
      ></span>
    </div>
  </div>

  @if (data) {
    <div class="modal-body">
      <div class="index-preview">
        <div class="form-control">
          <label for="">{{ 'TRACK_COMMENT' | translate }}</label>
          <textarea
            [(ngModel)]="data.comment"
            [placeholder]="'INSERT_TRACK_COMMENT' | translate"
          ></textarea>
        </div>
      </div>
    </div>
  }

  @if (confirmBtn || declineBtn) {
    <div class="modal-footer modal-footer--right">
      @if (declineBtn) {
        <button
          type="button"
          class="button button--outlined"
          (click)="hide('decline')"
        >
          {{ declineBtn | translate }}
        </button>
      }
      @if (confirmBtn) {
        <button
          type="button"
          class="button button--filled button--shadow"
          (click)="hide('confirm')"
        >
          {{ confirmBtn | translate }}
        </button>
      }
    </div>
  }
</div>
